import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  private readonly router = inject(Router);

  protected readonly isAdminRoute = this.router.url.startsWith('/admin');
  protected readonly imageSrc = '/assets/public/not-found-404.png';

  protected goToSafeRoute(): void {
    void this.router.navigateByUrl(
      this.isAdminRoute ? '/admin/dashboard' : '/'
    );
  }
}
